export const cutCornerInCardByIndex = (index, length) => {
  if (index === 0) return 'left';
  if (index === length - 1) return 'right';

  return null;
};
